var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"safe_message_content",domProps:{"innerHTML":_vm._s(_vm.safeMessageHtml)},on:{"click":_vm.handleContentClick}})}
var staticRenderFns = []

export { render, staticRenderFns }